import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import {
  helpId,
  contactUsId,
  directoryPageId,
  contactInfoId,
  billingInvoicesId,
  coachesAndStaffId,
  directoryPagePath,
  contactInfoPath,
  billingInvoicesPath,
  coachesAndStaffPath,
  helpPath,
} from './Mobile'
import { TabConfig } from './types'

export const useAllTabs = () => {
  return [
    {
      id: directoryPageId,
      to: directoryPagePath,
      label: 'Directory Page',
      disableLink: false,
    },
    {
      id: contactInfoId,
      to: contactInfoPath,
      label: 'Contact Info',
      disableLink: false,
    },
    {
      id: billingInvoicesId,
      to: billingInvoicesPath,
      label: 'Billing & Invoices',
      disableLink: false,
      externalLink:
        'https://affiliate.crossfit.com/affiliate-portal/payment-center',
    },
    {
      id: coachesAndStaffId,
      to: coachesAndStaffPath,
      label: 'Coaches & Staff',
      disableLink: false,
    },
    {
      id: helpId,
      to: helpPath,
      label: 'Help',
      disableLink: false,
      externalLink: 'https://crossfit.my.site.com/Support/s/',
    },
    {
      id: contactUsId,
      to: coachesAndStaffPath,
      label: 'Contact Us',
      disableLink: false,
      externalLink:
        'https://crossfit.my.site.com/Support/s/createrecord/New_Affiliate_Case?retUrl=https%3A%2F%2Fcrossfit.my.site.com%2FSupport%2Fs%2F',
    },
  ]
}

export const useTab = (id: TabConfig['id']) => {
  const allTabs = useAllTabs()
  const tab = useMemo(() => {
    return allTabs.find((tab) => tab.id === id)
  }, [id])

  return tab
}

export const useTabsByLocation = (): [TabConfig] => {
  const allTabs = useAllTabs()
  const path = useLocation().pathname
  const selectedTab = allTabs.find((tab) => tab.to === path)

  return [selectedTab]
}
